<template>
	<div>
		<b-breadcrumb :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
		<b-row>
			<b-col></b-col>
			<b-col cols lg="10">
				<b-card bg-variant="light" style="margin-top: 15px;">
					<b-form>
						<h2 class="title">{{$lang.settings.providers.new}}</h2>
						<hr>

						<b-form-group
							:label="$lang.settings.providers.idNumber">
							<b-form-input v-model="provider.idNumber"
								required
								v-mask="['##.###.###-#','#.###.###-#']" masked="false"
								:placeholder="$lang.settings.providers.idNumber" />
						</b-form-group>

						<b-form-group
							:label="$lang.settings.providers.code">
							<b-form-input v-model="provider.code"
								required
								:placeholder="$lang.settings.providers.code" />
						</b-form-group>

						<b-form-group
							:label="$lang.settings.providers.name">
							<b-form-input v-model="provider.name"
								required
								:placeholder="$lang.settings.providers.name" />
						</b-form-group>

						<b-form-group
							:label="$lang.settings.providers.address">
							<b-form-input v-model="provider.address"
								required
								:placeholder="$lang.settings.providers.address" />
						</b-form-group>

						<b-form-group
							:label="$lang.settings.providers.contactName">
							<b-form-input v-model="provider.contactName"
								required
								:placeholder="$lang.settings.providers.contactName" />
						</b-form-group>

						<b-form-group
							:label="$lang.settings.providers.contactEmail">
							<b-form-input v-model="provider.contactEmail"
								required
								:placeholder="$lang.settings.providers.contactEmail" />
						</b-form-group>

						<b-form-group
							:label="$lang.settings.providers.contactTitle">
							<b-form-input v-model="provider.contactTitle"
								required
								:placeholder="$lang.settings.providers.contactTitle" />
						</b-form-group>

						<b-form-group
							:label="$lang.settings.providers.totalCredit">
							<money v-model="provider.totalCredit" v-bind="money" class="form-control"></money>
						</b-form-group>
						<hr> <!-- MATERIALS SECTION -->
							<h2 class="title">{{$lang.settings.providers.materials.title}}</h2>
							<b-button variant="info" class="title" value="Save" v-on:click="addNewLineItem">{{$lang.buttons.new}}</b-button>
							<hr>
							<b-form>
								<div v-if="provider.materials.length === 0"><h5>{{$lang.settings.providers.noMaterials}}</h5></div>
								<div v-if="provider.materials.length > 0">
									<b-row v-for="(material, index) in provider.materials" :key="index">
										<b-col lg="1">
											#{{ index + 1 }}
										</b-col>
										<b-col>
											<b-form-group :label="$lang.settings.providers.materials.code" :placehoder="$lang.settings.providers.materials.code">
												<b-form-input v-model="material.code"
													:placeholder="$lang.settings.providers.materials.code" />
											</b-form-group>
										</b-col>
										<b-col>
											<b-form-group :label="$lang.settings.providers.materials.name" :placehoder="$lang.settings.providers.materials.name">
												<b-form-input v-model="material.name"
													:placeholder="$lang.settings.providers.materials.name" />
											</b-form-group>
										</b-col>
										<b-col lg="2">
											<b-form-group :label="$lang.settings.providers.materials.price" :placehoder="$lang.settings.providers.materials.price">
												<money v-model="material.price" v-bind="price" class="form-control"></money>
											</b-form-group>
										</b-col>
										<b-col lg="2">
											<b-form-group :label="$lang.settings.providers.materials.uom" :placehoder="$lang.settings.providers.materials.uom">
												<v-select label="price" v-model="material.uom" :options="$store.state.uoms" style="background-color: #FFF;" />
											</b-form-group>
										</b-col>
										<b-col lg="2">
											<b-form-group :label="$lang.settings.providers.materials.active" :placehoder="$lang.settings.providers.materials.active">
												<v-select label="price" v-model="material.active" :options="$store.state.active" style="background-color: #FFF;" />
											</b-form-group>
										</b-col>
									</b-row>
								</div>
							</b-form>
						<hr>
						<div>
							<b-row>
								<b-col></b-col>
								<b-col cols lg="4">
									<b-button variant="primary" class="title" block value="Save" v-on:click="createProvider"  >{{$lang.buttons.save}}</b-button>
								</b-col>
								<b-col lg="4">
									<b-button variant="danger"  class="title" block value="Cancel" @click="$router.go(-1)">{{$lang.buttons.cancel}}</b-button>
								</b-col>
								<b-col></b-col>
							</b-row>
						</div>
					</b-form>
				</b-card>
			</b-col>
			<b-col></b-col>
		</b-row>
	</div>
</template>

<script>
import { dateFormat } from '../../../utils.js'
import { mapState } from 'vuex'
import { Money } from 'v-money'
const utils = require('../../../utils.js');

export default {
	data() {
		return {
			provider: {
				id: '',
				idNumber: '',
				code: '',
				name: '',
				address: '',
				contactName: '',
				contactEmail: '',
				contactTitle: '',
				totalCredit: '',
				materials: [
					// {code: '', name: '', price: 0, uom: ''}
				],
				// uoms: []
			},
			money: {... utils.moneyConfig, precision: 0},
			price: {... utils.moneyConfig, precision: 2},
			dateFormat: dateFormat,
			breadcrumb: [{'text': this.$lang.settings.settings,'to': '/'},{'text': this.$lang.settings.providers.title,'to': '/providers'}, {'text': this.$lang.settings.providersNew, 'href': '#'}],
		}
	},
	components: {
		Money
	},
	methods: {
		createProvider() {
			this.$store.dispatch('createProvider', this.provider)
			this.$router.push('/providers')
		},
		addNewLineItem() {
			this.provider.materials.push({code: '', name: '', price: 0, uom: '', active: 'Yes'})
		}
	},
	created() {
		this.$Progress.start()

		if(this.$route.params.providerId) {
			let providerId = this.$route.params.providerId
			this.$store.dispatch('fetchProvider', { providerId }).then( () => {
				this.provider = this.$store.getters.provider;
			} )
		}

		// this.uoms = this.$store.getters.uoms;

		this.$Progress.finish()
	},
	computed: {
		...mapState(['currentUser'])
	}
}
</script>
